import styled from 'styled-components';

import SvgIcon from '../../../../shared/SvgIcon';

const Arrow = styled(SvgIcon)`
  opacity: 0.65;
  cursor: pointer;
  &:hover {
    opacity: 1;
  }
`;

export const RightArrow = styled(Arrow)`
  transform: rotate(270deg);
  margin-left: 20px;
`;

export const LeftArrow = styled(Arrow)`
  transform: rotate(90deg);
`;

export const NavigatorButtons = styled.div`
  margin-right: 30px;
  display: flex;
`;
